import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { ZipCodeValidator } from '../validators/zip-code.validator';

@Directive({
    selector: '[zip-code]',
    standalone: true,
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ZipCodeValidatorDirective,
            multi: true,
        },
    ],
})
export class ZipCodeValidatorDirective implements Validator {
    @Input() country: string;

    validate(control: AbstractControl): { [key: string]: any } | null {
        switch (this.country) {
            case 'US': {
                return ZipCodeValidator.unitedStates(control);
            }
            case 'CA': {
                return ZipCodeValidator.canada(control);
            }
            default: {
                return ZipCodeValidator.other(control);
            }
        }
    }
}
